<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>虚拟现实在概念设计中的定位、应用与价值</h1>
        </div>
        <div class="picture">
          <img class="cover-image" src="../assets/project16_1.jpg.webp" />
        </div>
        <div class="paper_published">
          Zou, N., Gong, Q.*, Chai, Q., &amp; Chai, C. (2023). The role of virtual reality technology in conceptual design: Positioning, applications, and value. Digital Creativity, 34(1).
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_2.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">1 引言</div>
        <div class="text">
          VR 作为关键数字技术在设计领域应用日益广泛，但其在概念设计中的作用尚未得到系统全面的综述梳理。概念设计包含洞察、生成、决策环节，与设计师认知活动高度相关。本文通过综述 18 年来的相关研究，将 VR 技术特征与概念设计各阶段认知需求相对应，梳理应用工具、分析优劣、发展规律与技术价值，揭示 VR 在概念设计中的定位与未来趋势，推动其更好融入设计早期流程。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">2 综述过程</div>
        <div class="text">
          综述过程主要分为四步：第一，基于设计信息循环模型，将概念设计界定为洞察（问题分析与灵感探索）、生成（表达构建与修改）、决策（对比与评判）三个阶段，明确各阶段对应的认知需求；第二，通过数据库检索开展文献搜集，筛选出 2005—2022 年的 78 篇代表性研究；第三，将 VR 应用归类为共情工具、灵感工具、沉浸式手绘、VR-CAD 系统、力触觉工具、手势建模、虚拟原型、协同评审等类型，分阶段分析优势与局限；第四，通过年度发文量统计分析发展趋势，识别出两次研究高峰，并总结 VR 技术价值与各阶段技术特征的匹配程度。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_3.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_4.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">3 结论</div>
        <div class="text">
          本综述系统阐明了 VR 在概念设计中的定位、应用与价值：VR 与三阶段认知需求高度匹配，为设计师提供沉浸式、直观化、协同化的设计支撑；其发展经历了技术驱动与应用深化阶段，价值在决策阶段最成熟，生成阶段次之，洞察阶段潜力巨大。现有局限主要包括成本高、精度不足、设备限制、系统集成不完整等。未来研究应聚焦全流程支撑、智能交互、以用户为中心的参与、设计知识融合，构建更系统高效的 VR 支撑概念设计体系。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project16Zh",
};
</script>

<style scoped>
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.picture img {
  width: 100%;
}
.cover-image {
  width: 88% !important;
  margin: 0 auto;
  display: block;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
